import React, { useEffect, useState } from 'react';
import { api } from '../lib/api';
import { Button } from '../components/ui/button';
import { Trash2, Phone, Mail } from 'lucide-react';
import { toast } from 'sonner';

const AdminMessages = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    const r = await api.get('/admin/messages');
    setItems(r.data || []);
    setLoading(false);
  };
  useEffect(() => { load(); }, []);

  const remove = async (id) => {
    if (!window.confirm('Delete this message?')) return;
    await api.delete(`/admin/messages/${id}`);
    setItems((a) => a.filter((x) => x.id !== id));
    toast.success('Deleted');
  };

  if (loading) return <div className="text-gray-500">Loading...</div>;

  return (
    <div className="max-w-5xl">
      <h1 className="font-display text-2xl text-[#5a1d3b] mb-1" style={{ fontWeight: 500 }}>Messages</h1>
      <p className="text-gray-500 text-sm mb-6">{items.length} message(s)</p>

      <div className="space-y-3">
        {items.map((m) => (
          <div key={m.id} className="bg-white border border-gray-200 rounded-xl p-5">
            <div className="flex items-start justify-between gap-4">
              <div className="flex-1 min-w-0">
                <h3 className="font-medium text-[#5a1d3b]">{m.name}</h3>
                <div className="flex flex-wrap gap-x-4 gap-y-1 mt-2 text-sm text-gray-600">
                  {m.email && <span className="inline-flex items-center gap-1.5"><Mail className="w-3.5 h-3.5" /> {m.email}</span>}
                  {m.phone && <span className="inline-flex items-center gap-1.5"><Phone className="w-3.5 h-3.5" /> {m.phone}</span>}
                </div>
                {m.message && <p className="mt-3 text-sm text-gray-700 whitespace-pre-line">{m.message}</p>}
                <div className="mt-2 text-xs text-gray-400">{new Date(m.created_at).toLocaleString()}</div>
              </div>
              <Button variant="ghost" size="sm" onClick={() => remove(m.id)} className="text-red-600">
                <Trash2 className="w-4 h-4" />
              </Button>
            </div>
          </div>
        ))}
        {items.length === 0 && <p className="text-center text-gray-500 py-12">No messages yet.</p>}
      </div>
    </div>
  );
};

export default AdminMessages;
